import { render } from "./ConfigureNotifications.vue?vue&type=template&id=5da78292"
import script from "./ConfigureNotifications.vue?vue&type=script&lang=js"
export * from "./ConfigureNotifications.vue?vue&type=script&lang=js"

import "./ConfigureNotifications.vue?vue&type=style&index=0&id=5da78292&lang=scss"
script.render = render

export default script